import { AlertTriangle } from "lucide-react";
import { ukDate } from "@/lib/utils";

export const activeInsolvencies = (caseRow) => (caseRow?.pg_insolvencies || []).filter((r) => !r.discharged_at);

export const PgInsolvencyBadge = ({ caseRow, testid }) => {
  const act = activeInsolvencies(caseRow);
  if (!act.length) return null;
  return (
    <span className="inline-flex items-center gap-1 text-[9px] uppercase font-semibold px-1.5 py-0.5 rounded border bg-red-50 text-red-800 border-red-300 mt-1 mr-1"
      title={act.map((r) => `${r.guarantor_name}: ${r.type_label}${r.case_reference ? ` (${r.case_reference})` : ""} ${ukDate(r.date)}`).join(" · ")}
      data-testid={testid || `pg-insolvency-badge-${caseRow.case_id}`}>
      <AlertTriangle className="w-2.5 h-2.5" /> PG {act.length === 1 ? act[0].insolvency_type.replace("_", " ") : `insolvent ×${act.length}`}
    </span>
  );
};
